/// <amd-module name="TFS/Views/ProjectOverviewPage/Components/WrappedComponentContextProvider" />
import * as React from "react";
import { IWrappedComponentProperties, WrappedComponent } from "VSS/Platform/Layout";

export interface IWrappedComponentContextProviderProps<T, P> extends IWrappedComponentProperties<P> {
    context: React.Context<T>;
}

export function WrappedComponentContextProvider<T, P>(props: IWrappedComponentContextProviderProps<T, P> & { children?: React.ReactNode; }): JSX.Element {
    return (
        <>
            <WrappedComponent
                {...props}
                onDependenciesResolved={async () => {
                    if (props.onDependenciesResolved) {
                        await props.onDependenciesResolved();
                    }
                }}
                loadingComponent={() => <>{props.children}</>}
            >
                {props.children}
            </WrappedComponent>
        </>
    );
}
